module.exports = __webpack_public_path__ + "img/profileIcon_1.ca2fbaf2.svg";